import React from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
    overrideComponent,
} from '@sheerid/jslib';
import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { generateTrackingId } from './lib/utils/generateTrackingId';
import { StepSuccessComponent } from './components/stepSuccess/StepSuccessComponent';
import { StepInactiveMilitaryPersonalInfoComponent } from './components/stepInactiveMilitaryPersonalInfo/StepInactiveMilitaryPersonalInfoComponent';
import { StepActiveMilitaryPersonalInfoComponent } from './components/stepActiveMilitaryPersonalInfo/StepActiveMilitaryPersonalInfoComponent';
import { StepCollectMilitaryStatusComponent } from './components/stepCollectMilitaryStatus/StepCollectMilitaryStatusComponent';
import { getRedirectUrl } from './lib/utils/redirectHandler';
import { getQueryParamsByName } from './lib/utils/browser';

const trackingId: string = `MV${generateTrackingId}`; // Don't forget to switch this back to a random generated tracking id

export const successRedirectUrl = getRedirectUrl(getQueryParamsByName('brand'));

setMetadata({ trackingIdentifier: trackingId });
setMetadata({ successRedirect: successRedirectUrl });

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

// @ts-expect-error
overrideComponent('StepInactiveMilitaryPersonalInfoComponent', StepInactiveMilitaryPersonalInfoComponent);

// @ts-expect-error
overrideComponent('StepActiveMilitaryPersonalInfoComponent', StepActiveMilitaryPersonalInfoComponent);

overrideComponent('StepCollectMilitaryStatusComponent', StepCollectMilitaryStatusComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

ReactDOM.render(
    <React.StrictMode>
        <App
            trackingId={trackingId}
        />
    </React.StrictMode>,
    document.getElementById('root'),
);
